import React from 'react';
import classNames from 'classnames';

import type { TabsProps } from './tabs.props';

import './tabs.scss';

const Tabs = ({ className, activeTab, tabs }: TabsProps) => (
  <div className={classNames('tabs', className)}>
    {tabs.map(({ label, name = label, onClick }) => {
      const isActiveTab = activeTab === name;
      return (
        <button
          key={name}
          className={classNames('tabs__item', isActiveTab && 'tabs__item_active')}
          tabIndex={isActiveTab ? -1 : 0}
          onClick={onClick}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default React.memo(Tabs);
